import {
  WATCHLIST_ITEM_ADDED,
  WATCHLIST_ITEM_REMOVED,
  WATCHLIST_NAVIGATED,
} from 'app/features/watchlist/actionTypes';
import { CENTER_RIGHT } from 'app/analytics/constants/positions';
import { ActionDetail } from 'app/analytics/helpers';
import { commonActionDetail, contentMediaById } from 'app/analytics/selectors';
import translations from 'app/features/localization/translations.json';

const watchlist = {
  [WATCHLIST_ITEM_ADDED]: (getState, { payload }) => ({
    type: 'track',
    name: 'Watchlist Item Added',
    properties: contentMediaById(getState(), payload),
  }),
  [WATCHLIST_ITEM_REMOVED]: (getState, { payload }) => ({
    type: 'track',
    name: 'Watchlist Item Removed',
    properties: contentMediaById(getState(), payload),
  }),
  [WATCHLIST_NAVIGATED]: getState => ({
    type: 'track',
    name: 'Watchlist Navigated',
    properties: ActionDetail({
      position: CENTER_RIGHT,
      textOfButtonOrLink: translations.success_cards_cta,
      ...commonActionDetail(getState()),
    }),
  }),
};

export default watchlist;
